import { styled } from 'parkdepot-shared/theme'

export const ActionsContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale600,
    width: '100%'
}))
